// extracted by mini-css-extract-plugin
export default {"unread":"styles_unread__IXz0n","smallFont":"styles_smallFont__-3Nkz"};